/* eslint-disable camelcase */
import { CriticalDatasetLabels, DetectorFoodDrink, DetectorFoodEat } from '../../enum'
import Vuetify from '../../plugins/vuetify'

const _t = (text) => Vuetify.framework.lang.t(text)

export class DetectorFoodEntry {
  constructor ({ eat_state = DetectorFoodEat.NONE, drink_state = DetectorFoodDrink.NONE } = {}) {
    this.eatState = eat_state // enums.DetectorFoodEat
    this.drinkState = drink_state // enums.DetectorFoodDrink
  }

  filters () {
    const result = {}
    for (const field of Object.keys(this)) {
      result[field] = false
    }
    return result
  }

  backendModel () {
    return {
      eat_state: this.eatState,
      drink_state: this.drinkState
    }
  }

  get textRepresentation () {
    const result = []

    if (this.eatState !== DetectorFoodEat.NONE) {
      result.push(_t(`$vuetify.criticalDataset.enums.DetectorFoodEat.${this.eatState}`))
    }

    if (this.drinkState !== DetectorFoodDrink.NONE) {
      result.push(_t(`$vuetify.criticalDataset.enums.DetectorFoodDrink.${this.drinkState}`))
    }

    return result.map(item => ({
      item,
      color: 'black',
      type: CriticalDatasetLabels.FOOD_DETECTOR
    }))
  }
}
